var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',[_vm._v("GASTOS")]),_c('CRUDIndex',{attrs:{"permissionRoot":'Gastos',"items":_vm.models,"headers":_vm.headers,"storeModel":_vm.storeModel,"storeModelPlural":_vm.storeModelPlural}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }